import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { H2 } from 'UIComponents/elements/headings';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import AssetCopierPanelFooter from './AssetCopierPanelFooter';
import { AssetCopierProvider } from '../providers/AssetCopierProvider';
import AssetCopierPanelBody from './AssetCopierPanelBody';
import ErrorBoundary from '../common/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssetCopierPanel(props) {
  const {
    onClose,
    assets,
    portableType,
    onCopyComplete
  } = props;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(AssetCopierProvider, {
      assets: assets,
      portableType: portableType,
      onCopyComplete: onCopyComplete,
      children: /*#__PURE__*/_jsxs(UIModalPanel, {
        "data-test-id": "asset-copier-panel",
        children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ui-multi-account-asset-copier.panel.title"
            })
          }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: onClose
          })]
        }), /*#__PURE__*/_jsx(UIDialogBody, {
          children: /*#__PURE__*/_jsx(AssetCopierPanelBody, {})
        }), /*#__PURE__*/_jsx(AssetCopierPanelFooter, {
          onClickDone: onClose
        })]
      })
    })
  });
}
export default AssetCopierPanel;